/**
The main entry point for FAQs.
Referenced by page.questions.liquid templates.
* */
import ReactDOM from 'react-dom';
import { Provider, createClient } from 'urql';
import { OV_GRAPHQL_URL } from './config/theme';
import FAQs from './components/FAQs';
import { jsx as _jsx } from "react/jsx-runtime";
var client = createClient({
  url: OV_GRAPHQL_URL
});

var init = function init(groups) {
  ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
    value: client,
    children: /*#__PURE__*/_jsx(FAQs, {
      groups: groups
    })
  }), document.getElementById('page-faqs'));
};

init();